// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2BlKC","requiredAsterisk":"Info_requiredAsterisk__1b7Xw"};